import "./App.css";
import * as anchor from "@project-serum/anchor";

import { getPhantomWallet } from "@solana/wallet-adapter-wallets";
import {
  useWallet,
  WalletProvider,
  ConnectionProvider,
} from "@solana/wallet-adapter-react";
import {
  WalletModalProvider,
  WalletMultiButton,
} from "@solana/wallet-adapter-react-ui";

import Fight from "./Fight";
import Home from "./Home";
import Ability from "./Ability";
import Shop from "./Components/Shop";
import Footer from "./Components/Footer";
import LandingPage from "./LandingPage";
import Header from "./Components/Header";

import { BrowserRouter as Router, Route } from "react-router-dom";

import {
  Grid,
  Box,
  Button,
  Image,
  SimpleGrid,
  Badge,
  Input,
  VStack,
  Heading,
  Text,
  Container,
  Flex,
  Center,
  HStack,
} from "@chakra-ui/react";

import { useEffect } from "react";

const wallets = [
  /* view list of available wallets at https://github.com/solana-labs/wallet-adapter#wallets */
  getPhantomWallet(),
];

const opts: anchor.web3.ConnectionConfig = {
  commitment: "processed",
};

const metadataProgramId = new anchor.web3.PublicKey(
  "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
);
const tokenProgram = new anchor.web3.PublicKey(
  "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
);

// const network = "http://127.0.0.1:8899";
const network = "https://api.devnet.solana.com";
const connection = new anchor.web3.Connection(network, opts);

const App = () => {
  const wallet = useWallet();

  if (!wallet.connected) {
    /* If the user's wallet is not connected, display connect wallet button. */
    return (
      <VStack
        gap={4}
        h="100vh"
        justifyContent="center"
        textAlign="center"
        mx="15%"
      >
        <Heading>Welcome to Bitslimes.io</Heading>
        <Text>
          This is a pre-alpha of our on-chain battle arena where NFT's are able
          to engage in combat that is entirely resolved on chain. This game
          utilisizes the fast transaction speeds and low fees on Solana to make
          an enjoyable on-chain experience possible.
        </Text>
        <Text fontSize="0.8em" as="i">
          Connect Your Wallet to Enter
        </Text>
        <WalletMultiButton />
      </VStack>
    );
  } else {
    return (
      <Router>
        <Flex bg="black" color="white" minH="100vh" flexDirection="column">
          <Header />
          <Route exact path="/">
            <Home connection={connection} />
          </Route>
          <Route path="/fight/:id">
            <Fight connection={connection} />
          </Route>
          <Route path="/abilities">
            <Ability connection={connection} />
          </Route>
          <Route path="/shop">
            <Shop connection={connection} />
          </Route>
          {/* <Footer /> */}
        </Flex>
      </Router>
    );
  }
};

/* wallet configuration as specified here: https://github.com/solana-labs/wallet-adapter#setup */
const AppWithProvider = () => (
  <ConnectionProvider endpoint="http://127.0.0.1:8899">
    <WalletProvider wallets={wallets} autoConnect>
      <WalletModalProvider>
        <App />
      </WalletModalProvider>
    </WalletProvider>
  </ConnectionProvider>
);

export default AppWithProvider;
